// Password validation utilities for password reset

export const validatePassword = (password) => {
  const errors = [];

  if (!password) {
    errors.push("كلمة المرور مطلوبة");
    return { isValid: false, errors };
  }

  if (password.length < 8) {
    errors.push("كلمة المرور يجب أن تكون على الأقل 8 أحرف");
  }

  if (!/(?=.*[a-zA-Z])/.test(password)) {
    errors.push("كلمة المرور يجب أن تحتوي على حرف واحد على الأقل");
  }

  if (!/(?=.*\d)/.test(password)) {
    errors.push("كلمة المرور يجب أن تحتوي على رقم واحد على الأقل");
  }

  return {
    isValid: errors.length === 0,
    errors,
  };
};

export const validateEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  if (!email) {
    return { isValid: false, error: "البريد الإلكتروني مطلوب" };
  }

  if (!emailRegex.test(email)) {
    return { isValid: false, error: "البريد الإلكتروني غير صحيح" };
  }

  return { isValid: true, error: null };
};

export const validatePasswordMatch = (password, confirmPassword) => {
  if (password !== confirmPassword) {
    return { isValid: false, error: "كلمتا المرور غير متطابقتان" };
  }
  return { isValid: true, error: null };
};

export const validateResetCode = (code) => {
  if (!code) {
    return { isValid: false, error: "كود إعادة التعيين مطلوب" };
  }

  if (code.length !== 6) {
    return { isValid: false, error: "كود إعادة التعيين يجب أن يكون 6 أرقام" };
  }

  if (!/^\d{6}$/.test(code)) {
    return {
      isValid: false,
      error: "كود إعادة التعيين يجب أن يحتوي على أرقام فقط",
    };
  }

  return { isValid: true, error: null };
};
